import { render, staticRenderFns } from "./Disagree.vue?vue&type=template&id=c1408852"
import script from "./Disagree.vue?vue&type=script&lang=js"
export * from "./Disagree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports